// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-radio[data-v-bc9f72f4] .custom-control-label:after,.custom-radio[data-v-bc9f72f4] .custom-control-label:before{width:20px;height:20px;top:5px}", ""]);
// Exports
module.exports = exports;
